import { Browser } from '@capacitor/browser';
import { isPlatform } from '@ionic/core';
import { logger } from './logger';

enum Protocol {
  MailTo = 'mailto',
}

const openLink = async (link: string) => {
  if (isPlatform('capacitor')) {
    try {
      const protocol = link.replace(/:.*/, '');
      const presentationStyle = isPlatform('ipad') ? 'fullscreen' : 'popover';
      if (protocol === Protocol.MailTo) {
        window.open(link);
      } else {
        await Browser.open({
          url: link,
          presentationStyle,
        });
      }
    } catch (error) {
      logger.error('could not open link', { error, link });
    }
  } else {
    window.open(link);
  }
};

export { openLink };
